/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateLpInspectionCouponWithChildDto } from '../../models/create-lp-inspection-coupon-with-child-dto';
import { LpInspectionCouponDto } from '../../models/lp-inspection-coupon-dto';

export interface LpInspectionCouponControllerCreateWithChild$Params {
  childId: string;
      body: CreateLpInspectionCouponWithChildDto
}

export function lpInspectionCouponControllerCreateWithChild(http: HttpClient, rootUrl: string, params: LpInspectionCouponControllerCreateWithChild$Params, context?: HttpContext): Observable<StrictHttpResponse<LpInspectionCouponDto>> {
  const rb = new RequestBuilder(rootUrl, lpInspectionCouponControllerCreateWithChild.PATH, 'post');
  if (params) {
    rb.query('childId', params.childId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LpInspectionCouponDto>;
    })
  );
}

lpInspectionCouponControllerCreateWithChild.PATH = '/api/lp-inspection-coupon/child';
